import { Component, OnInit } from '@angular/core';
import { AllapiService } from 'src/app/allapi.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  allPhotos: any = [];
  imgUrl: any;
  loadER: boolean = true;
  allPhotosDatabyID: any = [];
  showNowDefault: boolean = true;
  showNow: boolean = false;
  photos_Title: any;
  productservices: any;

  constructor(private server: AllapiService) {
    this.fetchPhots();
    this.imgUrl = this.server.mediaPicture;
  }

  ngOnInit() {
  }
  fetchPhots() {
    this.server.getApi('G4').subscribe((res) => {
      if (res.responseCode == 200) {
        this.allPhotos = res.response;
        this.loadER = false;
      } else {
        this.loadER = true;
      }
    })
  }
  OpenTab(Data) {
    this.server.topFunction();
    let value = {
      "pictureID": Data.ID
    }
    this.photos_Title = Data.picture_Title;
    this.server.postApi('P7', value).subscribe((res) => {
      this.showNowDefault = false;
      this.showNow = true;
      if (res.responseCode == 200) {
        this.allPhotosDatabyID = res.response;
        this.loadER = false;
      } else {
        this.loadER = true;
      }
      
    })
  }
  BackTab() {
    this.showNow = false;
    this.showNowDefault = true;
  }
  ngOnDestroy() {
    this.productservices = this.server.getApi('G4').subscribe((res) => {
      this.allPhotos = res.response;
    }).unsubscribe();
  }
}
